import api from '../client'

export const resourceApi = {
  list: async (orgSlug) => {
    const response = await api.get(`/${orgSlug}/resources`)
    return response.data
  },
  
  get: async (orgSlug, resourceId) => {
    const response = await api.get(`/${orgSlug}/resources/${resourceId}`)
    return response.data
  },
  
  create: async (orgSlug, resource) => {
    const response = await api.post(`/${orgSlug}/resources`, resource)
    return response.data
  },
  
  update: async (orgSlug, resourceId, updates) => {
    const response = await api.patch(`/${orgSlug}/resources/${resourceId}`, updates)
    return response.data
  },
  
  delete: async (orgSlug, resourceId) => {
    await api.delete(`/${orgSlug}/resources/${resourceId}`)
  },
  
  test: async (orgSlug, resourceId) => {
    const response = await api.post(`/${orgSlug}/resources/${resourceId}/test`)
    return response.data
  },
  
  getMetrics: async (orgSlug, resourceId) => {
    const response = await api.get(`/${orgSlug}/resources/${resourceId}/metrics`)
    return response.data
  },
  
  query: async (orgSlug, resourceId, query) => {
    const response = await api.post(`/${orgSlug}/resources/${resourceId}/query`, query)
    return response.data
  }
}
